<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Add Horse</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>Base information</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'Horse Name'"
          [type]="'text'"
          [placeholder]="'Enter horse name'"
          [(value)]="name"
        />
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="horseGenders"
          [placeholder]="'Select gender'"
          [multiple]="false"
          [(value)]="selectedGender"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Date of Birth'"
          [type]="'date'"
          [placeholder]="'Enter date of birth'"
          [(value)]="date_of_birth"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Breed'"
          [type]="'text'"
          [placeholder]="'Enter breed'"
          [(value)]="breed"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Color'"
          [type]="'text'"
          [placeholder]="'Enter color'"
          [(value)]="color"
        />
      </div>
    </div>

    <div class="row">
      <h3>Registration</h3>
    </div>
    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12 pb-0 mb-0">
        <app-input-component
          [label]="'Passport Number'"
          [type]="'text'"
          [placeholder]="'Enter Passport number'"
          [(value)]="passport_id"
        />
      </div>

      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="horseRegistries"
          [placeholder]="'Select registry'"
          [(value)]="selectedRegistry"
        />
      </div>
    </div>

    <div class="row mt-4">
      <h3>Vaccination</h3>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Vaccination Date'"
          [type]="'date'"
          [placeholder]="'Enter vaccination date'"
          [(value)]="vaccination_date"
        />
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Next Vaccination Date'"
          [type]="'date'"
          [placeholder]="'Enter next vaccination date'"
          [(value)]="next_vaccination_date"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-4 col-12">
        <h4>Image of your horse</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="horseImageFile = $event[0]"
        />
      </div>

      <div class="col-lg-4 col-12">
        <h4>Pedigree</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="pedigreeFile = $event[0]"
        />
      </div>

      <div class="col-lg-4 col-12">
        <h4>Vaccination card</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="vaccinationCardFile = $event[0]"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="'Save Horse'"
          [iconClass]="'fa fa-plus'"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
